import React from 'react'
import StoryIcon from './StoryIcon'


const RegisterIcon = ({template, archived, register, iconStyle={}, additionalTitle, onClick, templates, currentRegister, currentTemplate, noPlus, iconSize=37}) => {
    const registerTemplateData = (registerIcon) => !Array.isArray(templates) ? undefined : templates?.find?.((x)=>x._id==registerIcon?.template?._ref)
    const isActive = (registerIcon) => {
        if(!registerIcon?._id) return false
        if(registerIcon?._id == currentRegister?._id) return true
        if(registerIcon?._id == currentTemplate?._id) return true
        return false
    }
  
    return (
    <>    
        <div onClick={onClick}>
            <StoryIcon
            archived={archived}
            iconStyle={iconStyle}
            icon={register ? registerTemplateData(register)?.icon : template?.icon}
            title={register ? registerTemplateData(register)?.family : template?.family}
            iconSize={iconSize}
            fontSize={5}
            vertical
            plus={!register && !noPlus}
            additionalTitle={additionalTitle}
            isActive={isActive(register ? register : template)}
            />
            
        </div>
    </>
    )
} 

export default RegisterIcon
